<template>
    <div v-if="pendingInvitations.length > 0">
        <div class="title-section">
            {{ $t('student.you_have_pending_invitations') }}
        </div>

        <v-divider/>

        <student-invitation-card :invitation="lastInvitation"/>

        <go-to v-if="hasMoreInvitations" class="mt-0" :name="$t('common.see_all')" :to="{name: 'student.invitations'}"/>
    </div>
</template>

<script>
import StudentInvitationCard from "@/components/common/cards/StudentInvitationCard";
import {mapState} from "vuex";
import GoTo from "@/components/elements/buttons/goTo";

export default {
    name: "PendingInvitations",
    components: {GoTo, StudentInvitationCard},
    computed: {
        ...mapState(['studentInvitations']),
        pendingInvitations(vm = this) {
            return vm.studentInvitations.filter(invitation => invitation.status === 'pending')
        },
        hasMoreInvitations(vm = this) {
            return vm.pendingInvitations.length > 1
        },
        lastInvitation(vm = this) {
            return vm.pendingInvitations[0]
        }
    }
}
</script>

<style scoped>

.v-divider {
    height: 3px;
    max-height: 10px;
    background-color: var(--v-primary-base);
    margin-top: 10px;
    margin-bottom: 10px;
}

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

</style>